import React from "react";
import { DesignationPanelsContainer } from "./containers/DesignationPanelsContainer";
import { DesignationProvider } from "./context/DesignationProvider";
import { StyleProvider } from "./context/StyleProvider";
import { SessionProvider } from "./context/SessionProvider";
import { URLParametersProvider } from "./context/URLParametersProvider";
import { RentalProvider } from "./context/RentalProvider";
import { ProfileProvider } from "./context/ProfileProvider";
import { MagentoIntegrationContainer } from "./containers/MagentoIntegrationContainer";
import { StylePageSizes, StylePageStyle, StylePageSubscriptionSizes } from "../../common/interfaces";
import { StructuredData } from "./components/StructuredData";
import "./index.scss";

export type StylePageProps = {
  style: StylePageStyle;
  sizesResponse: StylePageSizes;
  subscriptionSizesResponse: StylePageSubscriptionSizes;
};

export const StylePage: React.FC<StylePageProps> = ({ style, sizesResponse, subscriptionSizesResponse }) => {
  return (
    <div className="c-style-page">
      <SessionProvider>
        <ProfileProvider>
          <StyleProvider
            serverStyle={style}
            sizesResponse={sizesResponse}
            subscriptionSizesResponse={subscriptionSizesResponse}
          >
            <URLParametersProvider>
              <DesignationProvider>
                <RentalProvider>
                  <MagentoIntegrationContainer />
                  <DesignationPanelsContainer />
                  <StructuredData />
                </RentalProvider>
              </DesignationProvider>
            </URLParametersProvider>
          </StyleProvider>
        </ProfileProvider>
      </SessionProvider>
    </div>
  );
};
